import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4 12c0-.5.5-1 1-1h14c.5 0 1 .5 1 1s-.5 1-1 1H5c-.5 0-1-.5-1-1"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 8a1 1 0 0 0 2 0V3.3a.3.3 0 0 1 .3-.3H8a1 1 0 1 0 0-2H2a1 1 0 0 0-1 1zM23 8a1 1 0 0 1-2 0V3.3a.3.3 0 0 0-.3-.3H16a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1zM1 16a1 1 0 0 1 2 0v4.7a.3.3 0 0 0 .3.3H8a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zM23 16a1 1 0 0 0-2 0v4.7a.3.3 0 0 1-.3.3H16a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }